export var StartEventConfig = {
    width: 40,
    height: 40,
};
export var EndEventConfig = {
    width: 40,
    height: 40,
};
export var ExclusiveGatewayConfig = {
    width: 40,
    height: 40,
};
export var ServiceTaskConfig = {
    width: 100,
    height: 80,
};
export var UserTaskConfig = {
    width: 100,
    height: 80,
};
export var theme = {
    rect: {
        radius: 5,
        stroke: 'rgb(24, 125, 255)',
    },
    circle: {
        r: 18,
        stroke: 'rgb(24, 125, 255)',
    },
    polygon: {
        stroke: 'rgb(24, 125, 255)',
    },
    polyline: {
        stroke: 'rgb(24, 125, 255)',
        hoverStroke: 'rgb(24, 125, 255)',
        selectedStroke: 'rgb(24, 125, 255)',
    },
    edgeText: {
        background: {
            fill: 'white',
            height: 14,
            stroke: 'transparent',
            radius: 3,
        },
    },
};
